const myAccordionItems = document.querySelectorAll('.sm_accordion-item');

myAccordionItems.forEach((item) => {
  const title = item.querySelector('.sm_accordion-title');
  const content = item.querySelector('.sm_accordion-content');

  title.addEventListener('click', () => {
    item.classList.toggle('active');
    if (item.classList.contains('active')) {
      content.style.minHeight = content.scrollHeight + 'px';
    } else {
      content.style.minHeight = '0';
    }
  });
});

// const accordionItems = document.querySelectorAll('.sm_accordion-faq-item');

// accordionItems.forEach((item) => {
//   const title = item.querySelector('.sm_accordion-title');
//   const content = item.querySelector('.sm_accordion-content');

//   title.addEventListener('click', () => {
//     item.classList.toggle('active');
//     if (item.classList.contains('active')) {
//       content.style.minHeight = content.scrollHeight + 'px';
//     } else {
//       content.style.minHeight = '0';
//     }
//   });
// });

const accordionItems = document.querySelectorAll('.tab_list .sm_accordion-faq-item');

accordionItems.forEach((item) => {
  const title = item.querySelector('.sm_accordion-title');
  const content = item.querySelector('.sm_accordion-content');

  title.addEventListener('click', () => {
    // Check if the clicked item already has the 'active' class
    const isActive = item.classList.contains('active');

    // Remove 'active' class and set content height to zero for all accordion items
    accordionItems.forEach((accordionItem) => {
      accordionItem.classList.remove('active');
      accordionItem.querySelector('.sm_accordion-content').style.minHeight = '0';
    });

    // If the clicked item was not active, add 'active' class and adjust content height
    if (!isActive) {
      item.classList.add('active');
      content.style.minHeight = content.scrollHeight + 'px';
    }
  });
});


